/* DON BRAVO — mobile compaction helpers (added by Claude session)
   1) Collapses very long product descriptions behind a Read More toggle (mobile only)
   2) Adds a sticky Add to Cart bar on product pages (mobile only) */
(function () {
  function init() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    /* ---- 1) description clamp ---- */
    document.querySelectorAll('.product-single__box__text.rte').forEach(function (el) {
      if (el.scrollHeight > 650) {
        var bg = window.getComputedStyle(document.body).backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)') el.style.setProperty('--db-desc-fade', bg);
        el.classList.add('db-desc-clamp');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'db-desc-toggle';
        btn.textContent = 'Read the full details +';
        btn.addEventListener('click', function () {
          el.classList.remove('db-desc-clamp');
          btn.remove();
        });
        el.insertAdjacentElement('afterend', btn);
      }
    });

    /* ---- 2) sticky add-to-cart ---- */
    var form = document.querySelector('form.js-product-form, form.db-product-form');
    if (!form) return;
    var mainBtn = form.querySelector('button[name="add"]:not([aria-hidden]), button[type="submit"].db-product-button') || form.querySelector('button[name="add"]');
    if (!mainBtn) return;
    var titleEl = document.querySelector('.product-single__title, #db-product-title, h1');
    var scope = form.closest('section') || document;
    var priceEl = scope.querySelector('.price__number, .db-product-price');

    var bar = document.createElement('div');
    bar.className = 'db-sticky-atc';
    var info = document.createElement('div');
    info.className = 'db-sticky-atc__info';
    var t = document.createElement('div');
    t.className = 'db-sticky-atc__title';
    t.textContent = (titleEl ? titleEl.textContent : document.title).trim();
    var p = document.createElement('div');
    p.className = 'db-sticky-atc__price';
    p.textContent = priceEl ? priceEl.textContent.trim() : '';
    info.appendChild(t); info.appendChild(p);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'db-sticky-atc__btn';
    b.textContent = 'Add to cart';
    b.addEventListener('click', function () {
      if (mainBtn.disabled) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (form.requestSubmit) { form.requestSubmit(mainBtn); } else { mainBtn.click(); }
    });
    bar.appendChild(info); bar.appendChild(b);
    document.body.appendChild(bar);

    var ticking = false;
    function updateBar() {
      ticking = false;
      var passed = mainBtn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', passed);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateBar); }
    }, { passive: true });
    updateBar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
